import React, { useState, useEffect } from 'react';
import axios from '../axios';
import { Container, Button, Table, Modal, Form } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import CSS của React-Quill
import parse from 'html-react-parser';
import './ConfigurationList.css'; // Import CSS

const ConfigurationList = () => {
  const [configurations, setConfigurations] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingConfig, setEditingConfig] = useState(null);
  const [configKey, setConfigKey] = useState('');
  const [configValue, setConfigValue] = useState('');

  useEffect(() => {
    fetchConfigurations();
  }, []);

  const fetchConfigurations = async () => {
    try {
      const res = await axios.get('/configurations', {
        headers: { 'x-auth-token': localStorage.getItem('token') }
      });
      setConfigurations(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSaveConfiguration = async () => {
    const sanitizedConfigValue = configValue.replace(/^<p>(.*)<\/p>$/gm, '$1'); // Loại bỏ các thẻ <p> bao quanh nội dung
    if (editingConfig) {
      // Update existing configuration
      try {
        await axios.put(`/configurations/${editingConfig._id}`, { configKey, configValue: sanitizedConfigValue }, {
          headers: { 'x-auth-token': localStorage.getItem('token') }
        });
        fetchConfigurations();
        setShowModal(false);
      } catch (err) {
        console.error(err);
      }
    } else {
      // Add new configuration
      try {
        await axios.post('/configurations', { configKey, configValue: sanitizedConfigValue }, {
          headers: { 'x-auth-token': localStorage.getItem('token') }
        });
        fetchConfigurations();
        setShowModal(false);
      } catch (err) {
        console.error(err);
      }
    }
  };

  const handleDeleteConfiguration = async (id) => {
    try {
      await axios.delete(`/configurations/${id}`, {
        headers: { 'x-auth-token': localStorage.getItem('token') }
      });
      fetchConfigurations();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditConfiguration = (config) => {
    setEditingConfig(config);
    setConfigKey(config.configKey);
    setConfigValue(config.configValue);
    setShowModal(true);
  };

  const handleAddConfiguration = () => {
    setEditingConfig(null);
    setConfigKey('');
    setConfigValue('');
    setShowModal(true);
  };

  return (
    <Container>
      <h2>Quản lý Cấu hình</h2>
      <Button onClick={handleAddConfiguration}>Thêm Cấu hình</Button>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>Mã cấu hình</th>
            <th>Nội dung cấu hình</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          {configurations.map((config) => (
            <tr key={config._id}>
              <td className="table-cell">{config.configKey}</td>
              <td className="table-cell">{parse(config.configValue)}</td>
              <td>
                <Button variant="warning" onClick={() => handleEditConfiguration(config)}>Sửa</Button>
                <Button variant="danger" onClick={() => handleDeleteConfiguration(config._id)}>Xóa</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal để thêm/sửa cấu hình */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{editingConfig ? 'Sửa Cấu hình' : 'Thêm Cấu hình'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formConfigKey">
              <Form.Label>Mã cấu hình</Form.Label>
              <Form.Control
                type="text"
                value={configKey}
                onChange={(e) => setConfigKey(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formConfigValue">
              <Form.Label>Nội dung cấu hình</Form.Label>
              <ReactQuill
                value={configValue}
                onChange={setConfigValue}
                modules={{
                  toolbar: [
                    [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
                    [{size: []}],
                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                    [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                    ['link', 'image'],
                    ['clean'],
                    [{ 'color': [] }, { 'background': [] }] // Tùy chọn màu chữ và nền chữ
                  ],
                }}
                formats={[
                  'header', 'font', 'size',
                  'bold', 'italic', 'underline', 'strike', 'blockquote',
                  'list', 'bullet', 'indent',
                  'link', 'image', 'color', 'background' // Định dạng màu chữ và nền chữ
                ]}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Hủy</Button>
          <Button variant="primary" onClick={handleSaveConfiguration}>Lưu</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ConfigurationList;
